<template>
    <div>
        <div id="panel-4" class="panel">
            <div class="panel-hdr ">
                <h2>
                    {{ __t('LIST') }} <span class="fw-300"><i>{{__t('MODIFIES')}}</i></span>
                </h2>

                <div class="panel-toolbar">
                    <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                        <i class="fal fa-plus"></i>
                    </button>

                    <button class="btn btn-panel waves-effect waves-themed"
                            data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <div class="filter_block mb-3">
                        <filter_modificators></filter_modificators>
                    </div>

                    <b-skeleton-table
                        v-if="is_load"
                        :rows=this.cur_records :columns="2" :hide-header=true :table-props="{ bordered: false, striped: true }"
                    >
                    </b-skeleton-table>

                    <div class="inbox_vue_list" v-if="!is_load">

                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="up"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>


                        <b-table
                            v-if="rows.length > 0"
                            :tbody-tr-class="rowClass"
                            striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                            <!-- header fields -->
                            <template v-slot:head(id)="data">
                                <div class="status_info" style="max-width: 50px">
                                    {{ __t('STATUS') }}
                                </div>
                            </template>

                            <template v-slot:head(ordering)="data">
                                <grid_list
                                    :list_ordering="'ordering'"
                                    :field_name="__t('ORDERING')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />

                            </template>

                            <template v-slot:head(uniq_id)="data">
                                <grid_list
                                    :list_ordering="'uniq_id'"
                                    :field_name="__t('UNIQ_ID')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(title)="data">
                                <grid_list
                                    :list_ordering="'name'"
                                    :field_name="__t('TTILE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(added)="data">
                                {{__t('DATE')}}
                            </template>



                            <template  v-slot:cell(id)="data">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        v-on:click="save_modif_publish(data.item)"
                                        :name="'cid[]'"
                                        v-model="data.item.published"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="data.item.id + '_cust_id'" />
                                    <label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
                                </div>
                            </template>


                            <template v-slot:cell(ordering)="data">
                                <div class="btn btn-primary btn-icon rounded-circle position-relative js-waves-off">
                                    <i class="fal fa-sort"></i>

                                    <span class="badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right">
									    {{data.item.ordering}}
								    </span>
                                </div>
                            </template>


                            <template v-slot:cell(uniq_id)="data">
                                <div class="">
                                    <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                        <div  class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_item(data.item)">
                                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                        </div>
                                        {{data.item.uniq_id}}

                                        <span class="small text-info pl-2">
                                            <i class="fal fa-lock" v-if="data.item.skeep_sync" :title="__t('MOD_SKIP_SYNC')"></i>
                                             <i class="fal fa-user-ninja" v-if="data.item.hidden" :title="__t('MOD_HIDDEN')"></i>
                                        </span>

                                        <span v-if="data.item.is_product" class="color-danger-700 ml-4">
                                           <i class="fal fa-barcode-read"></i>
                                        </span>
                                    </div>

                                    <div class="d-flex flex-start w-100">
                                        <div class="small badge border border-success">
                                            {{data.item.price}}
                                        </div>
                                        <div class="ml-3 small badge border border-info" v-if="obj_to_null(data.item.group)">
                                            {{data.item.group.title}}

                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(price)="data">
                                <div class="prod_price bold color-primary-900 mt-1">
                                    {{new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price))}}
                                    <span class="woocommerce-Price-currencySymbol  fs-sm"></span>
                                </div>
                            </template>

                            <template v-slot:cell(title)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html=nice_search(data.item.name)></span>
                                    <span class="small text-info pl-2">
                                        <i class="fal fa-lock" v-if="data.item.skeep_sync"></i>
                                    </span>
                                </div>

                                <div>
                                    <div class="small badge border border-warning">
                                        ID: {{data.item.id}}
                                    </div>
                                </div>

                                <div class="categ_name">
                                    <div class="small badge border border-primary text-primary" v-if="obj_to_null(data.item.address)">
                                        {{data.item.address}}
                                    </div>
                                </div>
                            </template>

                        </b-table>


                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                 key="down"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <modif_modal></modif_modal>

    </div>
</template>

<script>

    import {mapGetters} from "vuex";

    import modif_modal from "./modif_modal.vue";
    import filter_modificators from "./filter_modificators.vue";


    import Grid_list from "../../../sys/list/grid_list.vue";
    import Pagination_list from "../../../sys/list/pagination_list.vue";

    export default {
        name: "modificators",

        props : {
            active_categories: {
                type: Array,
                default: () => []
            },

        },
        components : {
            Grid_list,
            Pagination_list,

            modif_modal,
            filter_modificators,
        },
        data() {
            return {
                rows : [],

                pagination: {
                    total: 0,
                    limit: 30,
                    pagesCurrent: 1
                },

                list: {
                    direction: "DESC",
                    ordering: "ordering",
                    start: 0
                },

                filter: {
                    search: "",
                    groups: [],
                },


                component_type : "modifiers",
                grid_trigger : "modifier_inbox_change_state",

                is_load:true,
                is_check_all : false,
                is_filter_work : false,

                cur_records:35,
                active_items : [],
                fields : [

                    {
                        key : 'id',
                        label: '',
                        class:'text-center'
                    },

                    {
                        key : 'ordering',
                        label: '<i class="fas fa-sort"></i>',
                        class:'text-center hidden-md-down'
                    },

                    {
                        key : 'uniq_id',
                        label: '<i class="fal fa-cog width-2"></i>',
                        class:''
                    },


                    {
                        key : 'title',
                        label: 'r.title',
                        class:''
                    },

                    {
                        key : 'price',
                        label: this.__t('PRICE'),
                        class:''
                    },

                ],
            }
        },

        mounted() {
            this.load_items();
        },

        created() {
            EventBus.$on("search_modif_called",this.search_work);
            EventBus.$on("filter_select_change",this.filter_select);
            EventBus.$on('modif_groups_changed',this.filter_select);

            EventBus.$on("clean_modif_filter",this.clean_modifiers_filter);

            EventBus.$on("modifiers_reload_items",this.load_items);
            EventBus.$on(this.grid_trigger,this.change_state);

            EventBus.$on("reload_modifiers",this.load_items);

        },

        methods : {

            handleOrdering({ordering, direction}) {
                this.list.ordering = ordering;
                this.list.direction = direction;
                this.load_items();
            },

            handlePageChange({page, start}) {
                this.list.start = start;
                this.load_items();
            },

            search_work(search_str) {
                this.filter.search = search_str;
                this.list.start = 0;
                this.load_items();
            },

            filter_select(res) {
                this.filter[res.type] = res.value;
                this.list.start = 0;
                this.load_items();
            },

            clean_modifiers_filter() {

                this.filter = {
                    search: "",
                    groups: [],
                };

                this.list = {
                    direction: "DESC",
                    ordering: "ordering",
                    start: 0
                };

                this.load_items();
            },


            async load_items() {
                this.rows = [];
                this.is_load = true;

                await api.post('/internal/v1/catalog/modifiers', {
                    list: this.list,
                    filter: this.filter
                }).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rows = data.data;

                        if (data.message?.pagination) {
                            this.pagination = data.message.pagination;
                        }
                    }

                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
            },


            async save_modif_publish(item) {
                await api.patch('/internal/v1/catalog/modifiers/'+ parseInt(item.id) +'/state').then(({data}) => {
                    if (data.status === "operation_success") {
                        EventBus.$emit("modifiers_reload_items");
                    }
                })
                .catch(({response}) => {
                    item.published = prev;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            rowClass(item) {
                if (!item) return;
                return item.class;
            },

            open_item (item) {
                EventBus.$emit("modifier_edit",parseInt(item.id));
            },

            create() {
                EventBus.$emit("modifier_edit",0);
            },


            nice_search(str) {
                if (!this.filter.hasOwnProperty('search')) {
                    return str;
                }
                return str.replace(new RegExp(this.filter.search, "i"), match => {
                    return '<span class="text-danger">' + match + '</span>';
                });
            },
        },
        computed: {
            ...mapGetters({
                'user' : "user/getUser",
            }),
        }
    }
</script>

<style scoped>
    .table thead th:first-child {
        max-width: 20px;
    }

    .prod_price {
        font-size: 20px;
    }
</style>
